import { createFileRoute } from "@tanstack/react-router";

import { KycPhoneCapture } from "@/components/kyc/KycPhoneCapture";

export const Route = createFileRoute("/kyc_/capture/$token")({
  component: CaptureRoute,
});

function CaptureRoute() {
  const { token } = Route.useParams();
  return <KycPhoneCapture token={token} />;
}
